export default __webpack_public_path__ + "static/media/comlogo.f8339e0c.png";